export default __webpack_public_path__ + "static/media/Awshad CV.d2829df3.pdf";